import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { GradedUnit } from 'app/library/graded-unit/models/graded-unit.model';
import { IPartialGradeQuery } from 'app/library/partial-grade/interfaces/partial-grade.query.interface';
import { IEnvironment } from 'app/projects/core/src/lib/interfaces/environment.interface';
import { MAXBRAIN_ENVIRONMENT } from 'app/projects/core/src/lib/services/environment.token';
import { Observable } from 'rxjs';

export interface IPartialGradesAndTotalCount {
    data: IPartialGradeQuery[];
    pagination: {
        number_of_pages: number;
        number_of_results: number;
    };
}

@Injectable()
export class GradedUnitPartialGradesService {
    constructor(private http: HttpClient, @Inject(MAXBRAIN_ENVIRONMENT) private environment: IEnvironment) {}

    findGrades(gradedUnit: GradedUnit, search = '', sortBy = '', sortOrder = '', pageSize = 10, pageIndex = 1): Observable<IPartialGradesAndTotalCount> {
        let params = new HttpParams().set('page', pageIndex.toString()).set('limit', pageSize.toString()).set('gradedUnit', gradedUnit.id);

        if (search) {
            params = params.set('search', search);
        }

        if (sortBy && sortOrder) {
            switch (sortBy) {
                case 'userFullName':
                    sortBy = 'name';
                    break;
                case 'gradeNumericValue':
                    sortBy = 'grade';
                    break;
            }

            params = params.set('sortBy', sortBy);
            params = params.set('sortOrder', sortOrder);
        }

        return this.http.get<IPartialGradesAndTotalCount>(`${this.environment.apiUrl}/modules/${gradedUnit.module.id}/partial-grades/manager`, { params });
    }
}
